<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__warn">
      {{ 'ORDERS.DELETE_TITLE' | translate }}
    </h3>
    <p
      class="sp-color__primary sp-margin__top sp-margin__bottom-x4"
      [innerHTML]="'ORDERS.DELETE_MESSAGE' | translate : { amount }"></p>

    <app-shared-button
      class="sp-width__full"
      [button_class]="'sp-button__warn'"
      [spinner_class]="'sp-spinner__main'"
      [cta]="'GENERAL.CONFIRM_CTA'"
      [is_disabled]="is_delete_running"
      [is_spinner_visible]="is_delete_running"
      (click)="onDeleteClick()"></app-shared-button>
  </div>
</div>
